import * as R from 'ramda';

/**
 * Make sure that num has more places than the precision you're passing in
 * when using this round func.
 * @export
 * @param {number} num
 * @param {number} [precision=2]
 * @return {*}
 */
export function roundToPrecision(num, precision = 2) {
    const factor = 10 ** precision;
    return Math.round(num * factor) / factor;
}

export const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

/**
 * @param {number} numerator
 * @return {(denominator: number) => (funcName: string) => number}
 */
export const guardFromNaN = R.curry((numerator, denominator, funcName) => {
    const errorMessage = funcName
        ? `${funcName}: bad values received: numerator: ${numerator} denominator: ${denominator}`
        : `bad values received: numerator: ${numerator} denominator: ${denominator}`;
    if (R.isNil(numerator) || R.isNil(denominator)) {
        throw new Error(errorMessage);
    }
    return denominator > 0 ? numerator / denominator : 0;
});

/**
 * @param {number} min the lowest allowed value for the number
 * @param {number} number the number to be validated
 * @return {number}
 */
export const isAtLeast = R.curry(
    (min, number) => typeof Number(number) === 'number' && R.gte(number, min)
);

export const parseNumberAsPercent = x => {
    if (R.isNil(x)) {
        return '0%';
    }
    const number = (Math.round(x * 10000) / 100).toString();
    return `${number}%`;
};

export const parsePercentAsFixedNumber = x => {
    if (R.isNil(x)) {
        return 0;
    }
    const number = parseFloat(x.replace('%', ''));
    return isNaN(number) ? 0 : parseFloat((number / 100).toFixed(4));
};

export const abbreviateNumber = (value) => {
    const SI_POSTFIXES = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
    const tier = (Math.log10(Math.abs(value)) / 3) | 0;
    if (tier == 0) {
        return `${value}`;
    }
    const postfix = SI_POSTFIXES[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = value / scale;
    let formatted = scaled.toFixed(1) + '';
    if (/\.0$/.test(formatted)) formatted = formatted.substr(0, formatted.length - 2);
    return formatted + postfix;
};

export const insightNumberToPercent = (number) => {
    if (number === null || number === undefined || isNaN(number)) {
        return 'N/A';
    }

    return `${(number * 100).toFixed(2)}%`;
};

export const getMetricStringValue = (metricValue) => {
    if (metricValue === undefined || metricValue === null) {
        return '-';
    }
    return abbreviateNumber(parseFloat(metricValue.toFixed(2)));
};

export const formatInsightNumber = (number) => {
    return Intl.NumberFormat('en-US').format(number);
};



// WEBPACK FOOTER //
// ./common/number_helper.js